import React, { Component } from 'react';

class PhoneNumberPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: '',
      errorMessage: '',
    };
  }

  handleInputChange = (event) => {
    this.setState({ phoneNumber: event.target.value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { phoneNumber } = this.state;

    if (!/^\d{10}$/.test(phoneNumber)) {
      this.setState({ errorMessage: 'Please enter a valid 10-digit phone number' });
      return;
    }

    try {
        const response = await fetch(`${this.props.config.siteUrl}/wp-json/mm/v1/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ phone: phoneNumber }), // Ensure the key matches expected field name in API
        });
        const data = await response.json();
        // console.log('API Response:', data);
      
        if (data.success) {
          // Close popup on success
          this.props.togglePopup();
          this.setState({ phoneNumber: '', errorMessage: '' });
          window.location.reload();
        } else {
          // Show alert if response contains an error message
          alert(data.message || 'Failed to register. Please try again.');
        }
      } catch (error) {
        console.error('API call failed:', error);
        alert('Failed to submit phone number. Please try again.');
        this.setState({ errorMessage: 'Failed to submit phone number. Please try again.' });
      }
    }
      

  render() {
    // console.log("PhoneNumberPopup this.props.showPhonePopup", this.props.showPhonePopup)
    if (!this.props.showPhonePopup) return null; // Only render if showPhonePopup is true

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <div style={{textAlign: "flex"}}>
                    <div style={{width: "50%", float: 'left'}}>
                        <h2>Login</h2> 
                    </div>
                    <div style={{textAlign: "right", width: "50%", float: 'left'}}>
                        <button onClick={this.props.togglePopup}>Close</button>
                    </div>
                </div>
                <div className="popup-inner">
                <h2>Enter Phone Number</h2>
                <form onSubmit={this.handleSubmit}>
                    <input
                        maxlength="10"
                        type="text"
                        value={this.state.phoneNumber}
                        onChange={this.handleInputChange}
                        placeholder="Phone Number"
                    />
                    <div style={{marginTop:'10px'}}></div>
                    {this.state.errorMessage && <p className="error">{this.state.errorMessage}</p>}
                    <div style={{marginTop:'20px'}}></div>
                    <button type="submit">Submit</button>
                    <div style={{marginTop:'20px'}}></div>
                    {/* <button type="button" onClick={this.props.togglePopup}>Cancel</button> */}
                </form>
                </div>
            </div>
      </div>
    );
  }
}

export default PhoneNumberPopup;
